import session from "../../../stores/session"

const VacantCOTAlertsConfig = {
    translations: [],
    uuidColumn: "Core_SPID",
    productId: "vacant_cot_alerts",
    apiPrefix: "VACANT_COT_ALERTS",
    purchaseTypePrefix: "vaca",
    permissionPrefix: "VACANT_COT",
    navigationPath: "vacant-cot-alerts",
    exclusionReasons: session.company.exclusion_reasons_type === 'Water' ?
        [
            { value: 'Existing Live Account', label: 'Existing Live Account' },
            { value: 'Multiple Occupier/LL Query', label: 'Multiple Occupier/LL Query' },
            { value: 'Address/Data Quality Issue', label: 'Address/Data Quality Issue' },
            { value: 'Previous Occupier Provided', label: 'Previous Occupier Provided' },
            { value: 'Adjacent Occupier Provided', label: 'Adjacent Occupier Provided' },
            { value: 'De-registration', label: 'De-registration' },
            { value: 'Account Already Open - Same Occupier', label: 'Account Already Open - Same Occupier' },
            { value: 'Account Already Open - Different Occupier', label: 'Account Already Open - Different Occupier' },
            { value: 'Other Retailer', label: 'Other Retailer' },
            { value: 'No Consumption', label: 'No Consumption' },
            { value: 'Insufficient Information', label: 'Insufficient Information' },
            { value: 'Other', label: 'Other' }
        ]
        :
        [
            { value: 'No COT: Current Occupier', label: 'No COT: Current Occupier' },
            { value: 'No COT: Name Correction', label: 'No COT: Name Correction' },
            { value: 'No COT: Now Vacant', label: 'No COT: Now Vacant' },
            { value: 'Multiple Occupier/LL Query', label: 'Multiple Occupier/LL Query' },
            { value: 'Address/Data Quality Issue', label: 'Address/Data Quality Issue' },
            { value: 'Previous Occupier Provided', label: 'Previous Occupier Provided' },
            { value: 'Adjacent Occupier Provided', label: 'Adjacent Occupier Provided' },
            { value: 'De-registration', label: 'De-registration' },
            { value: 'Insufficient Information', label: 'Insufficient Information' },
            { value: 'Other', label: 'Other' }
        ],
    adcGroups: [
        "0.0-0.5",
        "0.5-1.0",
        "1-1.5",
        "1.5-2.0",
        "2.0+"
    ],
    statuses: ["New", "In Progress", "Complex", "Awaiting Customer", "Awaiting Visit"],
}

export default VacantCOTAlertsConfig;
